import { State } from "@/store/modules/gameKiller/index";

const getGameKillerData = (state: State): any => {
    return state.data;
};

const getGameKillerTimerVote = (state: State): any => {
    return state.timerVote;
};

const getGameKillerTimerReport = (state: State): any => {
    return state.timerReport;
};

const getGameKillerUserVoted = (state: State): any => {
    return state.userVoted;
};

const getGameKillerTimerKiller = (state: State): any => {
    return state.timerKiller;
};

const getGameKillerLastDead = (state: State): any => {
    return state.lastDead;
};

const getGameKillerTimerBan = (state: State): any => {
    return state.timerBan;
};


export default {
    getGameKillerData,
    getGameKillerTimerVote,
    getGameKillerTimerReport,
    getGameKillerUserVoted,
    getGameKillerTimerKiller,
    getGameKillerLastDead,
    getGameKillerTimerBan,
};